import { type OpportunitiesSearchOptions } from "@repo/api";
import {
  Icon,
  Text,
  chevronDownSmallIcon,
  chevronUpSmallIcon,
} from "@repo/skapa";
import { T } from "@repo/translation";

import {
  HideOnMobileSortableHeader,
  SortableHeader,
} from "./ProjectsTable.styled";

interface SortableHeaderCellProps {
  sort?: (sortKey: string) => void;
  sortKey?: string;
  translationKey?: string;
  options: OpportunitiesSearchOptions;
  align?: "left" | "right";
  hideOnMobile?: boolean;
}

export const SortableHeaderCell = ({
  sort,
  sortKey,
  translationKey,
  options,
  align,
  hideOnMobile,
}: SortableHeaderCellProps) => {
  const isActive = options.sortKey === sortKey;
  const HeaderComponent = hideOnMobile
    ? HideOnMobileSortableHeader
    : SortableHeader;
  return (
    <HeaderComponent
      active={isActive}
      onClick={() => {
        if (sort && sortKey) {
          sort(sortKey);
        }
      }}
      style={{ textAlign: align ?? "left" }}
      aria-sort={
        isActive
          ? options.sortOrder === "asc"
            ? "ascending"
            : "descending"
          : undefined
      }
    >
      <Text bold={isActive}>
        {translationKey && <T translationKey={translationKey} />}
        {options.sortKey && isActive && (
          <Icon
            paths={
              options.sortOrder === "desc"
                ? chevronDownSmallIcon
                : chevronUpSmallIcon
            }
          />
        )}
      </Text>
    </HeaderComponent>
  );
};
